import React from 'react';

import styled, { css } from 'styled-components';

import { Tag, TagProps } from 'components';

export type StatusBadgeVariant = 'default' | 'pending';

type StatusBadgeProps = {
  value: string;
  variant?: StatusBadgeVariant;
} & TagProps;

const getVariantStyles = (variant: StatusBadgeVariant) => {
  switch (variant) {
    case 'pending':
      return css`
        color: ${props => props.theme.custom.palette.teal600};
        background-color: ${props => props.theme.custom.palette.teal50};
        font-size: 14px;
        font-weight: 500;
        font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto,
          sans-serif;
        text-align: center;
        padding: 2px 4px;
        border-radius: 6px;
        border: 1px solid #ccfbf1;
        display: inline-block;
        min-width: 70px;
      `;
    default:
      return css`
        background: ${props => props.theme.custom.palette.muted50};
        color: ${props => props.theme.custom.palette.gray};
        border-radius: 4px;
        font-size: 0.6rem;
        font-weight: 500;
        text-transform: uppercase;
        letter-spacing: 0.025em;
        border: 1px solid ${props => props.theme.custom.palette.muted100};
      `;
  }
};

const StyledStatusBadge = styled(Tag)<{ variant: StatusBadgeVariant }>`
  ${props => getVariantStyles(props.variant)}
`;

export const StatusBadge: React.FC<StatusBadgeProps> = ({
  value,
  variant = 'default',
  ...props
}) => {
  return <StyledStatusBadge value={value} variant={variant} {...props} />;
};
